const constants = {
    TEST_NAME: 'User test'
}
  
export { constants }
  